import * as React from "react"
export const Svg_058 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M20.016 22.733a2.157 2.157 0 0 0 2.154-2.155 2.157 2.157 0 0 0-2.154-2.154 2.157 2.157 0 0 0-2.155 2.154c0 1.188.967 2.155 2.155 2.155Z"
    />
    <path fill="url(#b)" d="M4.61 14.949H0v36.016h52.086v-4.61H4.609V14.95Z" />
    <path
      fill="url(#c)"
      d="M59 42.899V8.035H8.066v34.864H59Zm-16.409-16.71h10.071v3.458h-10.07V26.19Zm0 6.915h10.071v3.457h-10.07v-3.457Zm-6.914-6.914h3.457v3.457h-3.457V26.19Zm0 6.914h3.457v3.457h-3.457v-3.457ZM20.016 14.967a5.618 5.618 0 0 1 5.611 5.611 5.618 5.618 0 0 1-5.611 5.612 5.618 5.618 0 0 1-5.612-5.612 5.618 5.618 0 0 1 5.612-5.611Zm5.611 14.68v3.457H14.404v-3.457h11.223Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={18.858}
        x2={20.904}
        y1={19.07}
        y2={22.383}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={12.045}
        x2={25.868}
        y1={20.351}
        y2={52.704}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={19.845}
        x2={33.132}
        y1={13.264}
        y2={44.679}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)